import React, { useEffect } from 'react';
import { cookieConsentManagerKey, isServer } from '~/config/public/environment';

const CookieDeclarationInjection = () => {
  useEffect(() => {
    if (!isServer && cookieConsentManagerKey) {
      // Dynamically load the Cookiebot cookie declaration script
      const script = document.createElement('script');
      script.id = 'CookieDeclaration';
      script.src = `https://consent.cookiebot.com/${cookieConsentManagerKey}/cd.js`;
      script.type = 'text/javascript';
      script.async = true;
      document.body.appendChild(script);

      // Cleanup to remove the script if the component is unmounted
      return () => {
        if (script) {
          document.body.removeChild(script);
        }
      };
    }
  }, []);

  if (!cookieConsentManagerKey) {
    return null;
  }

  return <div id="CookieDeclaration" />;
};

export default CookieDeclarationInjection;
